//Built-in libraries

//Third party libraries

import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
//Custom components
import Button from '@/components/UI/Button';
import { HookCheckbox } from '@/components/UI/HookForm/Form/Checkbox';
//Services
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export default function Scope() {
  const { setCurrentStep } = useApplicationFormContext();
  const {
    formState: { errors },
    trigger,
    watch,
  } = useFormContext();

  // State to control when validation errors should be shown
  const [showValidationErrors, setShowValidationErrors] = useState(false);

  // Watch scope values to see what's selected
  const scopeValues = watch('scope');

  // Debug: Log errors and scope values
  console.log('Scope errors:', errors.scope);
  console.log('Scope values:', scopeValues);

  // Helper function to get the single error message for scope validation
  const getScopeErrorMessage = () => {
    if (errors.scope?.message && showValidationErrors) {
      console.log('Scope error message:', errors.scope.message);
      return errors.scope.message as string;
    }
    return null;
  };

  // Manual validation check for scope
  const getManualScopeError = () => {
    if (!showValidationErrors) return null;

    if (!scopeValues) return 'At least one service must be selected';

    const selectedServices = Object.values(scopeValues).filter((val) => val === true);
    if (selectedServices.length === 0) {
      return 'At least one service must be selected';
    }
    return null;
  };

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>Scope</h3>
        <div className='my-5 font-semibold'>
          <h4>Services to be provided at property</h4>
        </div>
        <div className='grid grid-cols-1 h-screen/4'>
          <HookCheckbox name='scope.roofing' id='scope.roofing' className='col-span-1'>
            <label htmlFor='roofing'>Roofing</label>
          </HookCheckbox>

          <HookCheckbox name='scope.plumbing' id='scope.plumbing' className='col-span-1'>
            <label htmlFor='plumbing'>Plumbing</label>
          </HookCheckbox>

          <HookCheckbox name='scope.electrical' id='scope.electrical' className='col-span-1'>
            <label htmlFor='electrical'>Electrical</label>
          </HookCheckbox>

          <HookCheckbox name='scope.heatAndAir' id='scope.heatAndAir' className='col-span-1'>
            <label htmlFor='heat-Air'>Heat & Air</label>
          </HookCheckbox>

          <HookCheckbox name='scope.structural' id='scope.structural' className='col-span-1'>
            <label htmlFor='structural'>Structural</label>
          </HookCheckbox>

          <HookCheckbox name='scope.painting' id='scope.painting' className='col-span-1'>
            <label htmlFor='painting'>Painting</label>
          </HookCheckbox>

          <HookCheckbox name='scope.sewer' id='scope.sewer' className='col-span-1'>
            <label htmlFor='sewer'>Sewer</label>
          </HookCheckbox>
        </div>

        {/* Show form validation error or manual validation error */}
        {(getScopeErrorMessage() || getManualScopeError()) && (
          <div className='text-red-500 text-sm mt-2'>{getScopeErrorMessage() || getManualScopeError()}</div>
        )}

        <div className='flex gap-4 justify-end mt-5'>
          <Button label='Previous' btnStyle='neutral' type='button' onClick={() => setCurrentStep((prev) => prev - 1)} />
          <Button
            label='Next'
            btnStyle='primary'
            type='submit'
            onClick={async () => {
              // Show validation errors and trigger validation
              setShowValidationErrors(true);
              console.log('Triggering scope validation...');
              const isValid = await trigger('scope');
              console.log('Scope validation result:', isValid);
              console.log('Scope errors after trigger:', errors.scope);
            }}
          />
        </div>
      </div>
    </div>
  );
}
